import { CurrencyModel } from '@sosocio/creator/interfaces';
import ApiService from 'services/ApiService';

class CurrencyService extends ApiService<CurrencyModel> {
	constructor() {
		super('currency');
	}
}

export default new CurrencyService();
